import { render } from "./SnapChatStoryReview.vue?vue&type=template&id=02e36c9a"
import script from "./SnapChatStoryReview.vue?vue&type=script&lang=js"
export * from "./SnapChatStoryReview.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__